/*
  Canvas by Numbers - "Complete your kit" add-ons on the product page
  (snippets/cbn-addons.liquid). Same behaviour as Nummora's nm-addons:

  - The shopper ticks add-ons, then clicks Add to cart as usual.
  - The theme adds the kit first (window.onSubmitAtcForm in product.js).
  - Only if the kit really went in, the ticked add-ons are added right after it,
    one request, through the shared cart queue (window.cbnCartQueue from
    cbn-gift.js), so the free-gift script can never overwrite them.
  - Any add-on that did not stick is sent once more, then the drawer is redrawn
    and the boxes are unticked.
*/
(() => {
    if (window.__cbnAddonsBound) return
    const orig = window.onSubmitAtcForm
    if (typeof orig !== 'function') return
    window.__cbnAddonsBound = true

    const cartJs = () => {
        const q = window.cbnCartQueue
        const get = () => (q ? q.fetch : fetch)('/cart.js', { credentials: 'same-origin' }).then((r) => r.json())
        return q ? q.run(get) : get()
    }
    const qty = (cart, id) => cart.items.filter((l) => l.variant_id === id).reduce((n, l) => n + l.quantity, 0)
    const addItems = (items) => fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
    })

    window.onSubmitAtcForm = async (form, event) => {
        const outside = form.closest('#offcanvas-cart, #cart, .modal, #product-bought-together')
        const box = outside ? null : document.querySelector('[data-cbn-addons]')
        const checked = box ? [...box.querySelectorAll('input[type="checkbox"]:checked')] : []
        if (!checked.length) return orig(form, event)

        event.preventDefault()
        const items = checked.map((c) => ({ id: Number(c.value), quantity: 1 }))
        // Queued before the kit's own add, so it is the cart as it was before this click
        const beforeP = cartJs().catch(() => null)
        await orig(form, event)

        try {
            const before = await beforeP
            const afterKit = await cartJs()
            if (before && afterKit.item_count <= before.item_count) return // kit was not added (sold out, error)

            let res = await addItems(items)
            let cart = await cartJs()
            const missing = items.filter((i) => qty(cart, i.id) < qty(afterKit, i.id) + i.quantity)
            if (missing.length) {
                res = await addItems(missing)
                cart = await cartJs()
            }
            checked.forEach((c) => { c.checked = false })
            if (typeof window.refreshCartContents === 'function') await window.refreshCartContents(res)
        } catch (e) {
            console.warn('[cbn-addons]', e)
        }
    }
})()
